import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import StoreModal from "./storeModal";
import { useLocation, useNavigate } from "react-router-dom";
const Main = ({ totalOutStanding, data }) => {
  const sapmoney = useSelector((state) => state.sapmoney);
  const location = useLocation();
  const selectedOutstandingMerchantData = useSelector(
    (state) => state.selectedOutstandingMerchant
  );
  const [selectedOutstandingMerchant, setSelectedOutstandingMerchant] =
    useState(selectedOutstandingMerchantData);

  const router = useNavigate();
  const dispatch = useDispatch();
  console.log(selectedOutstandingMerchant);
  const dataUser = useSelector((state) => state.dataUser);
  const [merchantStores, setMerchStores] = useState([]);
  const mhhsMerchId = useSelector((state) => state.mhhsMerchId);
  const [show, setShow] = useState(false);
  const dash = location.pathname;
  const mhhsMerchUser = useSelector((state) => state.mhhsMerchUser);
  const mhhsMerchEmpId = useSelector((state) => state.mhhsMerchEmpId);
  const id =
    mhhsMerchUser === "merchant-employee" ? mhhsMerchEmpId : mhhsMerchId;

  useEffect(() => {
    if (sapmoney === true) {
      setSelectedOutstandingMerchant({
        ...selectedOutstandingMerchantData,
        merchuser: {
          merchcompany: selectedOutstandingMerchantData?.merchcompany,
          phoneNo: selectedOutstandingMerchantData?.phoneNo,
          email: selectedOutstandingMerchantData?.email,
          countryCode: selectedOutstandingMerchantData?.countryCode,
        },
      });
    }
  }, [selectedOutstandingMerchantData]);

  console.log(selectedOutstandingMerchant);
  //Get Stores
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/merch-store/for-mhsss`, {
        params: {
          // limit: 3,
          // skip: 0,
          // page: storesCurrentPage,
          sortBy: "createdAt:desc",
          merchUserId: id,
        },
        headers: {
          Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
        },
      })
      .then((data) => {
        setMerchStores(data?.data?.rows);
      })
      .catch(() => {});
  }, []);

  const Div = ({ title, content }) => {
    if (title === "Total Outstanding Amount")
      return (
        <div className="flex flex-row justify-between">
          <div className="text-md font-medium leading-6 text-gray-600">
            {title}
          </div>
          <div
            className={`
              text-md leading-6 bg-primary rounded-md text-white pl-2 pr-2 cursor-pointer capitalize"
            `}
          >
            {content}
          </div>
        </div>
      );
    else
      return (
        <div className="flex flex-row justify-between">
          <div className="text-md font-medium leading-6 text-gray-600">
            {title}
          </div>
          <div
            className={`${
              title === "Email" ? "" : "capitalize"
            }text-md leading-6 text-gray-700 `}
          >
            {content}
          </div>
        </div>
      );
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/merch-user/${id}/status`, {
        headers: {
          Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
        },
      })
      .then((data) => {
        dispatch({
          type: "SELECTED_OUTSTANDING_STATUS",
          num: data?.data,
        });
      })
      .catch(() => {
        // Handle error
      });
  }, []);
  return (
    <div>
      <div className="flex sm:gap-5 gap-2 sm:flex-row flex-col">
        <div
          className="sm:w-1/4 bg-white rounded-md p-4 w-full
        "
        >
          <header className="px-2 py-4 flex flex-col justify-center items-center text-center">
            <img
              className={`${
                dash === "/MHSSS/dashboard/outstanding/person"
                  ? "hidden"
                  : "inline-flex object-cover border-4 border-primary rounded-full  bg-primary text-indigo-600 h-24 w-24"
              }`}
              src={
                selectedOutstandingMerchant?.merchuser?.merchcompany !== null
                  ? selectedOutstandingMerchant?.merchuser?.merchcompany?.logo
                  : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAMAAABC4vDmAAAA4VBMVEX////7toxBQUE9IxTOmHT/uo/7tIk+Pj46IBH/v5P/vZE4ODj2s4n6zbIrAADduaQ4PD4pKSkzMzMmAAAwFwjrq4M5HQvcoXvf39/q6uozEwA1FwATAAAgAAAqEQDzrYJVVVWTk5Ozs7NqampISEj09PQuCAC8h2aNY0mOhoXIkG7Z1tX+8+z92sX7wJz8yKnHnYXAwMCmpqZxXVEsNjt+fn5fU0yJbl1SSUSvhmyxp6KakY1NOjM+JB5oWleBdXBSNid1UDlhPyykdFhaRz6wkH+1oJb+5tlELiMUFBSYdmKGA6l9AAAH2UlEQVR4nM2bbVfaShSFCcmQkEQrNEMABXkVBNQGhKtVWxDv1fr/f9CdSQiQkNeZE+n+0rUqKzzss+fMmRByuRT6WRfTSjl9qqV5i9TqnCqpoUTx9LmTIZNVrzAwiWLl6rqfFdP4hY2J6PuvjErYf04fqK2uMqL6fcXORKjesqCy6iwh3+n0dwZQInOgXK9+gjM9fedkEisvY2Cm6jOvUaJY/wUM9XTKzUQagwXK1K+EGaUoRuOiYSSCOv8F2kNDEqU0xeVqPTDxMBnVKeh+E5QoYtHreoSRqiKEXxP1i/M3QCbrsJcrhrgydYSQQIUkJRFVA3ABPh1AGeIQqw6QreLASEJVB+yg1z4o5WJloj0k6tW6mQCq8gy22fR/nXttWo6KXqTEXtXBol578+S8ucIHSERqEqqrayio6sfeuynGUA9iomkXYztDZQnVqsZ77VwR1yiYiXhlvsYG66IKBGU19phGYUjUK33YiCnhd6hZYbrr5w2pGM5kx31JS6is1iGVPF8AQe124+YwmomYhVdNRVSW5jLYssoHUKi2gzB5r4jibajQ6NVQjJEUYtULUKh+u73TGMYy2claLy9eUcgmfQ40v7y5vdMYJIGyA98c6MGbdB0o6dsZQQnsmkEq6msd28206UODap8fGyhFTMpEoyWggUEKPlC8vas+h4FyDzLKa9za84psPMaqWBx6xhqo8dOFIu+QCkpQ1w2RLsd9qgrQqXQLFdul/CIDDVkb6v4IWHmG6QlLZijS4Vc6cWy0g1I+YKDclsAAJaCRKXhGQKUCMxLP6oyZsqkcx3a7zhUMlLvNsDi1NWzb309hoNwNublmhhL0lWvVKcw+09mMLo2BygxFOykolDvkNaIGvFirRAUUanzuXO8ifnAJV3FlgAbdvQ90gdmZSP0aoFDuuU/hgRKwA6WIQEd354SsLPmg7AxUGkAdPfezaRh0SNC5oGjSjbd//wM6uZ8gPGyShs4HRZq6scIqegdhmqgC1leGMeRhEsh4rBhYx4VbEKj3AkbkTN5cc3QEu6cbA+K1XgCBurmkdVs1eKEMe6XgwgQGSrCnyIRnmVCo5sr+9xIMSlcHTZ5dhmjVXKugULopSIbEBzVsjFRsEiiQk8M7hdJNkWfrI/vM8AIjk0JBMOUmFAqbL4mPosFQ64YACaXrgolHH1y9k87ppLFghGH61OSWXAqPVlxMZEx4VZGpC/gEBCp3R08kOtd2vLvA5Q0M1A3mq9yeiOUwe1/undulHZR5C9KmiG6hoIhRQJGi9TNhCkiuA1Q92hRMCcIscpU7KCY7VRBW6bgIlSiqmwIAk1AQwIpn6x0AqQC28rZU3F4VYW2yxW0UUCv36ITTKpgx2CfO+hUAm8GebrmoChkkKsfbFsBXnqMJ+z0zYhTYnucTT9QziTnVhB0qo5hTcViVlVEce02GRrFblVmiqBhTlalRzL0qS6NybG09k614Xww7YEHNmImlgJmmfKO0Bcy8eFQpm1XGK89VugJ+RfGo7lJQZTRGcVF9SaAcTQoJqTKbogKphERUXxTyVFSFuy8Kuav3+AoCfQuTRpPbv48pl/sWbRW6/HYMKCny7hCWjgMlhd7uR7opHQtKMkOYMPnb0aACzbJtOiqUZPqeb0aCgyRJX9nNfVAEC7tPJAmCvnGJ/OeXbjEHUITAxLquY4zNLaeOjgJ1Ykohcm66HweqoOMgIrwJ2ZGg6I1x00+0TfzRoOijryRLJhWJleeh/iNC2Vy2/O3quFAhOgJUv/MjDurHNLNf+gaq1m6VH2K+fEcP5VYb6scfsap2uqWynL+PfsxEfbzPy+VSt/MVXNa8VdLyRPIi+tu2hUxfpZV7806WZexXLeKRZr8Z0Vnkb2gezzYvkzXbr0zAatZ0LjseuVCzCKv02dneS7WS1m3DFrJfs9rdnrzzaKP78EdykHTvfS2po9ZrzTvjPqdl/erY6kzbXe0PCbYPyLZqEQ61ODt8vSxrpT9/8vPraccaMz0v2CfutMjyKZcDcFyqMKuQFMC0yxi5KnUtJVeNJLqkBbnjhZqFOTULh9q5Vmql4Kq2W55ER1AFWxVl1L60Uqud7AHZ6rXsT3Q41Czwmy011ihXclmex2PVpuVywgtS3Qc9foZM/9KLUrnUjimi1UqDRKz6Jwjqn6RGbbB6Uc+o1+alpIXb6jBVSEp7Dbk0D22s1ZQ2UZ19Hhr1mc4oqnIrhMrKJ1tyXt37n8xBOE2iXGlyYAmtiC4ZBfXpW4BqykRtJJcDqKw8E1M+3/PeTkC4x3Yd+dCrceLe5JcvVSyJ2lD5var1WPLkXOvBkyr8wPrp8nLP07D63fTrbitPqtRPlphvpHX355opBxOh2neKg4l0hule8dgW3hbqcRt19MgFlS/tCjhnDpQteeEuQIQXXB8vr21/5zrmuxBZgK5Vu+MCq2R3ZphzJYpCPWyOEPoDL5Sb9WqJ80IkVc6v7NQBX6KoSs4meM1rFO1VjlPsPWqrsp2qfo//Sk6q+BOVpx2U1s8CYHIOpnriKThKGt1s2nz9YKP7EUIj/kQRaW26w4BAnS1UNegAml50/dUgIpWnZ/iDkzqb5F41N+ZvCLbOZjOYT5cvjXMWEFQ+9jydVCWLc0DIQuU272acgcim3IVyHUxyN9f6+6BaOcazR5bq5Y5NEKS/Eup/Z3XjBdin3FoAAAAASUVORK5CYII="
              }
              alt=""
            />
            <img
              className={`${
                dash === "/MHSSS/dashboard/outstanding/person"
                  ? "inline-flex object-cover border-4 border-primary rounded-full  bg-primary text-indigo-600 h-24 w-24"
                  : "hidden"
              }`}
              src={
                selectedOutstandingMerchant?.merchcompany !== null
                  ? selectedOutstandingMerchant?.merchcompany?.logo
                  : "data:image/png;base64,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"
              }
              alt=""
            />
            <h1
              className={`${
                dash === "/MHSSS/dashboard/outstanding/person"
                  ? "hidden"
                  : "text-xl text-gray-700 font-bold mt-2"
              }`}
            >
              {selectedOutstandingMerchant?.merchuser?.merchcompany !== null
                ? selectedOutstandingMerchant?.merchuser?.merchcompany?.name
                : "------"}
            </h1>
            <h1
              className={`${
                dash === "/MHSSS/dashboard/outstanding/person"
                  ? "text-xl text-gray-700 font-bold mt-2"
                  : "hidden"
              }`}
            >
              {selectedOutstandingMerchant?.merchcompany !== null
                ? selectedOutstandingMerchant?.merchcompany?.name
                : "------"}
            </h1>
            <h2 className="text-base md:text-sm text-primary font-bold">
              {/* <h1 className="text-primary font-semibold border-b-0 hover:border-b-4 hover:border-b-indigo-300 transition-all mb-2"> */}
              Merchant
              {/* </h1> */}
            </h2>
          </header>

          
        </div>
        <div className="sm:w-3/4 w-full bg-white p-5 rounded-md">
          <div className="w-full bg-[#FAFAFA] p-4 gap-7 flex h-full">
            <div className="w-[45%] flex flex-col gap-2">
              <Div
                title="Phone :"
                content={
                  dash === "/MHSSS/dashboard/outstanding/person"
                    ? `${selectedOutstandingMerchant?.countryCode || ""} ${
                        selectedOutstandingMerchant?.phoneNo || ""
                      }`
                    : selectedOutstandingMerchant?.merchuser?.countryCode
                    ? `${selectedOutstandingMerchant.merchuser.countryCode} ${selectedOutstandingMerchant.merchuser.phoneNo}`
                    : "------"
                }
              />
              {/* <Div
                title="Email"
                content={
                  dash === "/MHSSS/dashboard/outstanding/person"
                    ? selectedOutstandingMerchant?.email
                    : selectedOutstandingMerchant?.merchuser?.email
                }
              /> */}

              <div className="flex flex-wrap w-full justify-between">
                <h2 className="text-md font-medium leading-6 text-gray-600">
                  Email Id :
                </h2>
                <p className="text-right break-words text-md leading-6 text-gray-700">
                  {dash === "/MHSSS/dashboard/outstanding/person"
                    ? selectedOutstandingMerchant?.email
                    : selectedOutstandingMerchant?.merchuser?.email}
                </p>
              </div>
              <Div
                title="Number of stores :"
                content={merchantStores?.length}
              />
              {merchantStores?.slice(0, 1)?.map((store, index) => (
                <Div
                  key={index}
                  title={`Store Name ${index + 1} :`}
                  content={store?.customStoreName}
                />
              ))}
              {merchantStores?.length > 1 && (
                <div
                  className="text-md font-medium leading-6 text-primary text-right cursor-pointer"
                  onClick={() => setShow(true)}
                >
                  view all
                </div>
              )}

              {/* <Div title="Store Name 1:" content={"Fullfilment"} />
              <Div title="Store Name 2:" content={"Yup Store"} /> */}
            </div>
            <div className="w-[55%] flex flex-col gap-2">
              <p
                onClick={() => {
                  router("/MHSSS/merchProfile", {
                    state: {
                      totalOutStanding: totalOutStanding,
                      merchuser: selectedOutstandingMerchant?.merchuser,
                    },
                  });
                }}
                className="text-right text-primary font-bold text-[0.95rem] cursor-pointer"
              >
                View Complete Profile
              </p>

              <Div
                title="Last Transaction Date :"
                content={moment(data?.[0]?.createdAt)?.format(
                  "MM/DD/YYYY hh:mm A"
                )}
              />
              <Div
                title="Total Outstanding Amount :"
                content={`$${totalOutStanding}`}
              />
            </div>
          </div>
        </div>
      </div>
      {show && (
        <StoreModal setShowStoreModal={setShow} stores={merchantStores} />
      )}
      {/* <Table /> */}
    </div>
  );
};

export default Main;
